import { App } from "antd";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import {
  addSpeaker,
  deleteSpeaker,
  renameSpeaker,
} from "store/bailiff/draft/dialog/draft_dialog.action";
import {
  draftDialogSpeakersRawSelector,
  draftDialogSpeakersSelector,
} from "store/bailiff/draft/dialog/draft_dialog.selector";
import { draftDialogEditedSpeakersSelector } from "store/bailiff/draft/dialog_edited/dialog_edited.selector";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
export const useActionDraftSpeaker = () => {
  // -------------------------- VAR -----------------------------
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get("tab") || "not_edit";
  const { message } = App?.useApp();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  const speakers = useSelector(draftDialogSpeakersSelector);
  // -------------------------- FUNCTION ------------------------
  const handleAddSpeaker = (object, form) => {
    if (!speakers) return message.error("speaker not found!");
    dispatch(addSpeaker({ data: speakers, speaker: object }));
    setSearchParams({ tab });
    form?.resetFields();
  };

  const handleDeleteSpeaker = (id) => {
    if (!speakers) return message.error("speaker not found!");
    dispatch(deleteSpeaker({ data: speakers, id }));
  };

  const handleChangeSpeakerName = (id, label) => {
    if (!speakers) return message.error("speaker not found!");
    dispatch(renameSpeaker({ data: speakers, id, name: label }));
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return { handleAddSpeaker, handleDeleteSpeaker, handleChangeSpeakerName };
};

//refine
export const useActionDraftSpeakerRefine = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const rawSpeakers = useSelector(draftDialogSpeakersRawSelector);
  const editedSpeakers = useSelector(draftDialogEditedSpeakersSelector);
  const data = editedSpeakers?.length > 0 ? editedSpeakers : rawSpeakers || [];
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return { data };
};
